import Model, { attr } from '@ember-data/model';
import { isPresent } from '@ember/utils';
import { computed } from '@ember/object';

export default Model.extend({
  name: attr('string'),
  city: attr('string'),
  state: attr('string'),
  cityAndState: computed('city', 'state', function () {
    return [this.city, this.state].filter((x) => isPresent(x)).join(', ');
  }),
});
